import React, { useEffect, useMemo, useRef, useState } from "react";

import { my_trips_tabs } from "../../component/TripManagement/myTripsPage/components/myTripsConstants";
import { INITIAL_BREADCRUMBS_LIST } from "../../constant/bookingInProgressConstant";
import { HomePageNav } from "../../constant/common";
import { USER_NAVIGATING_TO_BOOKING_PAGE_FROM } from "../../enums";
import { useLocalStorage } from "../../hooks/useLocalStorage";
import { useSessionStorage } from "../../hooks/useSessionStorage";
import { iCountryData, iItineraryDetailsData } from "../../interface/common";
import {
  AirportDataTypes,
  BaggageApiResponse,
  BookingDetails,
  FareDetail,
  FlightChangeTypes,
  FlightSelectedOptions,
  HotelPagination,
  OnboardingStep,
  PromoDetail,
  PromosApplyResponse,
  TemplateData,
  UserInfo,
  airportAddressFieldTypes,
  iAppConfig,
  iChatData,
  iSelectRoomTypes,
  iSignUp,
  onBoardFormTypes,
  payTypes,
  searchOptionTypes,
  selectFlightTypes,
  showMoreTypes,
} from "../../types";
import { accomodationsData, foodPreferencesData } from "../../utils/initialData";
import { iBreadList, iGlobalContext, iOpenResultDetail, iSelectedHotelRoom, iSelectedHotelRoomArr } from "./interface";
import { useSessionStorageV1 } from "../../hooks/useSessionStorageV1";
import { iHotelTravelersList } from "../../component/BookingInProgress/context/TravelersHotelContext";
import { isEmbedMode } from "../../utils/embedMode";

export const StateContext = React.createContext({} as iGlobalContext);

export function StateProvider({ children }: any) {
  const [promoReviewCartData, setPromoReviewCartData] = useLocalStorage("_zenvoya_promo_review_cart_data", {});
  const cancelHandleBookClickRef = useRef(null);
  const [promptTemplate, setPromptTemplate] = useLocalStorage("_zenvoya_prompt_template", []);
  const [isAdminChat, setIsAdminChat] = useSessionStorage("_zenvoya_is_admin_chat", false);
  // Session-scoped (per-tab) via useSessionStorageV1 — NOT useSessionStorage,
  // whose name lies (it persists to localStorage and would leak the askZoya
  // Q&A across browser sessions). The askZoya hooks read/write these same keys
  // directly through the sessionStorage helpers, so all accessors stay on one
  // store. See useSessionStorage vs useSessionStorageV1.
  const [flightChatData, setFlightChatData] = useSessionStorageV1("_zenvoya_flight_chat_data", []);
  const [hotelChatData, setHotelChatData] = useSessionStorageV1("_zenvoya_hotel_chat_data", [[]]);
  const [showHotelRoomDetails, setShowHotelRoomDetails] = useState(false);
  const [askZoyaRecordId, setAskZoyaRecordId] = useLocalStorage("_zenvoya_record_id", {
    flights: "",
    hotels: [],
  });
  const [guestList, setGuestList] = useLocalStorage("_zenvoya_guest_list", []);
  const [hotelTravelersList, setHotelTravelersList] = useLocalStorage(
    "_zenvoya_hotel_travelers_list",
    [] as iHotelTravelersList[]
  );
  const [userLocation, setUserLocation] = useLocalStorage("_zenvoya_user_location", {});
  let abortController = new AbortController();
  const abortControllerRef = useRef<AbortController | null>(null);
  const [destinationListGeneratedGAEventsFlag, setDestinationListGeneratedGAEventsFlag] = useLocalStorage(
    "_zenvoya_destinationListGeneratedGAEventsFlag",
    false
  );
  const [openTripFromURL, setopenTripFromURL] = useSessionStorage("_zenvoya_open_trip_from_url", {
    type: "",
    flag: false,
    userId: "",
  });
  const [isValidAccessToken, setIsValidAccessToken] = useSessionStorage(
    "_zenvoya_is_valid_token",

    false
  );
  const [isLazyLoaded, setIsLazyLoaded] = useState<boolean>(false);
  // Captured once at provider mount; the URL `?embed=1` flag does not change
  // mid-session and embed mode must not flip live (toggling would race the
  // ResizeObserver effect in App.tsx).
  const isEmbed = isEmbedMode();
  const [accessJWT, setAccessJWT] = useLocalStorage("_zenvoya_access_JWT", "");
  const [onboardingOpenFrom, setOnboardingOpenFrom] = useLocalStorage("_zenvoya_onboarding_open_from", {
    from: "",
    data: "",
  });
  // const [activeBreadCrumbs, setActiveBreadCrumbs] = useState(INITIAL_BREADCRUMBS_LIST[0] as iBreadList);
  // const [breadList, setBreadList] = useState<iBreadList[]>(INITIAL_BREADCRUMBS_LIST);
  const [activeBreadCrumbs, setActiveBreadCrumbs] = useSessionStorageV1(
    "_zenvoya_active_breadcrumbs",
    INITIAL_BREADCRUMBS_LIST[0] as iBreadList
  );
  const [breadList, setBreadList] = useSessionStorage(
    "_zenvoya_breadcrumbs_list",
    INITIAL_BREADCRUMBS_LIST as iBreadList[]
  );
  const [openLoaderOverlay, setOpenLoaderOverlay] = useState(false);
  const [iosNativeLoginData, setIosNativeLoginData] = useSessionStorage<{
    username: string;
    email: string;
  }>("_ios_native_login_data", {
    username: "",
    email: "",
  });
  const [isUserJustBookedTrip, setIsUserJustBookedTrip] = useSessionStorage(
    "_trip_trove_is_user_just_booked_trip",
    false
  );
  const [bookClickBeforeLoginFlag, setBookClickBeforeLoginFlag] = useState(false);
  const [searchBeforeLoginFlag, setSearchBeforeLoginFlag] = useState(false);
  const [socketId, setSocketId] = useSessionStorage<string | null>("socket_id", null);
  const [inputFocus, setInputFocus] = useState(false);
  const [hasMoreTripPagination, setHasMoreTripPagination] = useState<any>("more");
  const [fareId, setFareId] = useLocalStorage<string>("fareIdDetails", "");

  const [shouldUserNavigateBacktoTripDetailsPage, setShouldUserNavigateBackTotripDetailsPage] = useSessionStorage(
    "__user_tripDetails_pageState",
    false
  );
  const [isFetchingHotelDetails, setIsFetchingHotelDetails] = useState(false);
  const [isFetchingPreference, setIsFetchingPreference] = useState(false);
  const [isFetchingAirports, setIsFetchingAirports] = useState(false);
  const [isFetchingBaggageAndFare, setIsFetchingBaggageAndFare] = useState(false);
  const [isFetchingFare, setIsFetchingFare] = useState(false);
  const [isFetchingMobileAirports, setIsFetchingMobileAirports] = useState(false);
  const [isCheckingFlight, setIsCheckingFlight] = useState(false);
  const [checkFlightDetails, setCheckFlightDetails] = useState<boolean>(false);
  const [isFetchingFlights, setIsFetchingFlights] = useSessionStorageV1("isFetchingFlights", false);
  const [isFetchingHotels, setIsFetchingHotels] = useSessionStorageV1("isFetchingHotels", false);
  const [noFlightFound, setNoFlightFound] = useState(false);
  const [hotelInputFieldMissingError, setHotelInputFieldMissingError] = useState<boolean>(false);
  const [flightInputFieldMissingError, setFlightInputFieldMissingError] = useState<boolean>(false);
  const [isUpdatingPaymentDetails, setIsUpdatingPaymentDetails] = useState(false);
  const [baggageAndFareRules, setBaggageAndFareRules] = useState<BaggageApiResponse | null>(null);
  const [fareDetails, setFareDetails] = useState<FareDetail[] | null>(null);
  // Id the fares currently shown in the Select-Fare dialog belong to. NON-persisted:
  // it must reflect ONLY the live dialog, not survive refresh/other searches like the
  // shared, persisted `selectFlight` does. See interface.ts for the rationale.
  const [selectedFareContext, setSelectedFareContext] = useState<{
    encryptedKey: string;
    uniqueId: string;
    fareIds: string[];
  }>({
    encryptedKey: "",
    uniqueId: "",
    fareIds: [],
  });
  const [onBoardingStep, setOnBoardingStep] = useSessionStorageV1<OnboardingStep>("onBoardSteps", "lookingFor");
  const [selectedHotelRoom, setSelectedHotelRoom] = useSessionStorage<iSelectedHotelRoom | null>(
    "selected_hotel_room",
    null
  );
  const [selectedHotelRoomArr, setSelectedHotelRoomArr] = useSessionStorage<iSelectedHotelRoomArr[]>(
    "selected_hotel_room_arr",
    []
  );
  const [getHotelRoomsBody, setGetHotelRoomsBody] = useSessionStorage<any>("_get_hotel_rooms_body", null);
  const [showSelectRoomModal, setShowSelectRoomModal] = useState(false);
  const [selectRoom, setSelectRoom] = useState<iSelectRoomTypes>({
    isSelectRoom: false,
    isHotelDetailsExpanded: false,
    expandedHotelId: "",
  });
  const [openOverlayScreen, setOpenOverlayScreen] = useSessionStorage("_trip_trove_open_overlay", false);
  const [hotelDetailsPageId, setHotelDetailsPageId] = useSessionStorage("hotel_details_pageId", "");
  const [showReviewsModal, setShowReviews] = useSessionStorage("set_show_reviews", false);
  const [isCanclPolModalOpen, setIsCancPolModalOpen] = useState(false);
  const [showPropertyDetails, setShowPropertyDetails] = useSessionStorage("show_property_details", false);
  const [openResultDetail, setOpenResultDetail] = useState<iOpenResultDetail | null>(null);
  const [showMoreFlag, setShowMoreFlag] = useState(false);
  const [nav, setNav] = useSessionStorage("_trip_trove_nav", HomePageNav.LANDING_PAGE);
  const [myTripActiveTab, setMyTripActiveTab] = useSessionStorage("_myTripTab", my_trips_tabs[0]);
  const [activeTripDetailsTab, setActiveTripDetailsTab] = useSessionStorage(
    "_trip_trove_trip_details_active_tabs",
    "ITINERARY"
  );
  const [signUp, setSignUp] = useSessionStorage<iSignUp>("_signup", {
    name: "",
    email: "",
    password: "",
  });
  // ZIPCODE
  const [zip, setZip] = useState<number>();
  // header background
  const [headerBackground, setHeaderBackground] = useState("transparent");
  interface ObjType {
    id: number;
    data: string;
    check: boolean;
  }
  interface MonthsType {
    id: number;
    data: string;
    numOfDays: string;
    year: string;
    check: boolean;
  }
  const [showZoho, setShowZoho] = useState<boolean>(false);
  const [viewPreference, setViewPreference] = useState<boolean>(false);
  const [climate, setClimate] = useSessionStorage("_trip_trove_climate", [] as ObjType[]);
  const [population, setPopulation] = useSessionStorage("_trip_trove_population", [] as ObjType[]);
  const [experience, setExperience] = useSessionStorage("_trip_trove_experience", [] as ObjType[]);
  const [accomodations, setAccomodations] = useSessionStorage("_trip_trove_accomodation", accomodationsData);
  const [foodPreferences, setFoodPreferences] = useSessionStorage("_trip_trove_food_preferences", foodPreferencesData);
  const [months, setMonths] = useSessionStorage("_trip_trove_months", [] as MonthsType[]);
  const [budget, setBudget] = useSessionStorage("_trip_trove_budget", [] as any[]);
  // Onloading of Itienerary details state
  const [itineraryDetailsLoad, setItineraryDetailsLoad] = useState(false);
  // Staring and Dest State
  const [startingValue, setStartingValue] = React.useState({
    value: "",
    flag: false,
  });
  const [destValue, setDestValue] = React.useState({ value: "", flag: false });
  // User Location state
  const [latLong, setLatLong] = useState({
    lat: "",
    long: "",
  });
  // API Response Data
  const [apiResponse, setApiResponse] = useSessionStorage("_trip_trove_api_response", []);
  const [singleItineraryDetails, setSingleItineraryDetails] = useSessionStorage(
    "_trip_trove_single_itinerary_details",
    {}
  );
  const [data, setData] = useState("");
  // First two category Display state
  const [firstTwoCategoryState, setFirstTwoCategoryState] = React.useState(false);
  // Destination selected Flag
  const [selectedDestFlag, setSelectedDestFlag] = useSessionStorage("_trip_trove_select_destination_flag", false);
  // Menu State
  const [menuOpenState, setMenuOpenState] = React.useState(false);
  // Log in in Createa account
  const [loginCreateAccountState, setLoginCreateAccountState] = useState({
    flag: false,
    page: "",
  });
  const [saveScreenState, setSaveScreenState] = React.useState(false);
  // IS logged in state
  const [isLogin, setIsLogin] = useState(false);
  // Edit account
  const [prevNav, setPrevNav] = useSessionStorage("_trip_trove_prev_nav", "");
  // Edit account pre Route
  const [prevRoute, setPrevRoute] = useSessionStorage("_trip_trove_prev_route", "");
  const [modifyFlightStatus, setModifyFlightStatus] = useSessionStorage("modifyFlightStatus", "");
  // Itinerary Individual Details
  const [itinerayDetails, setItineraryDetails] = useState({});
  // Starting and Destination country
  const [startDestCountry, setStartDestCountry] = React.useState({
    start: "",
    dest: "",
  });
  // Number of Days Slider
  const [sliderValue, setSliderValue] = React.useState(3);
  // Log in flag
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [internationDest, setInternationalDest] = React.useState(false);
  //click on signin button from menu state
  const [signInClick, setSignInClick] = useState(false);
  // Trip with N number of days
  const [tripForNDays, setTripForNDays] = useSessionStorage("_trip_trove_trip_for_N_days", []);
  // Add more id
  const [addMoreId, setAddMoreId] = useState("");
  // Plan  Trip message
  const [fetchingPlanTripMessage, setFetchingPlanTripMessage] = React.useState("Creating trip plan...");
  // Reset Passsword Token
  const [resetPasswordToken, setResetPasswordToken] = React.useState("");

  //flight view
  const [expandedFlightId, setExpandedFlightId] = useState<string | null>(null);
  // shared Itinerary ID
  const [sharedItineraryId, setSharedItineraryId] = useSessionStorage("_trip_trove_shared_itinerary_id", "");
  const [tripOrItinearyId, setTripOrItinearyId] = useSessionStorage("_trip_trove_trip_id", "");
  const [itineraryId, setItineraryId] = useSessionStorage("itineraryId", "");
  // Abort Get trip plan
  const [abortTripAPICall, setAbortTripAPICall] = React.useState(false);
  // Plan trip stream Data
  const [dataStream, setDataStream] = React.useState("");
  const [tripPlanDataStream, setTripPlanDataStream] = React.useState<any>([]);
  // Extra Metadata
  const [extraMeta, setExtraMeta] = useSessionStorage("_trip_trove_extra_meta", {
    orginatedCity: "",
    destinationCity: "",
    selectedMonth: "",
    year: "",
    internationalFlag: false,
    numberOfDaysSelected: 2,
    numberOfExperienceSelected: "",
    planTripArray: [],
  });
  //View or edit state
  const [editViewState, setEditViewState] = React.useState(false);
  // State to add a Add more button in experience
  const [moreButton, setMoreButton] = useState(false);
  const [expHeight, setExpHeight] = useState(0);
  // Query State
  const [query, setQuery] = useSessionStorage("_trip_trove_query", {
    listingQuery: "",
    planTripQuery: "",
    updateTripQuery: "",
  });
  const [payDetails, setPayDetails] = useState<payTypes>({
    discountAmount: 0,
    secretKey: "",
    paymentIntentId: "",
    itineraryID: "",
    flightFareDetails: {
      baseFare: 0,
      tax: 0,
      totalFare: 0,
    },
    hotelFareDetails: {
      baseFare: 0,
      tax: 0,
      totalFare: 0,
    },
    fareBreakdown: {
      flights: {
        baseFare: 0,
        departureDate: "",
        returnDate: "",
        route: "",
        taxesAndFees: 0,
        total: 0,
        travellers: {
          adults: 0,
          children: 0,
          infants: 0,
          seniors: 0,
        },
      },
      hotels: [
        {
          baseFare: 0,
          checkIn: "0",
          checkOut: "",
          city: "",
          dueAtCheckIn: 0,
          hotelName: "",
          nights: 0,
          rooms: 0,
          taxesAndFees: 0,
          total: 0,
        },
      ],
    },
    price: {
      totalAmount: 0,
      discountAmount: 0,
      totalAmountAfterDiscount: 0,
      paymentId: "",
      promo: {
        code: "",
        description: "",
        id: "",
        status: "",
        message: "",
        errorCode: 0,
      },
    },
  });
  const [screen, setScreen] = useSessionStorageV1("screen_details", "");
  const [openLeaveReviewDialog, setOpenLeaveReviewDialog] = useState(false);
  const [showWhoComingWithYouModal, setShowWhoComingWithYouModal] = useState(false);
  const [activityData, setActivityData] = useSessionStorageV1<any>("activity_search", null);
  const [activitySearchParams, setActivitySearchParams] = useSessionStorageV1<any>("activity_search_params", null);
  const [selectedTicketActivity, setSelectedTicketActivity] = useState<any>(null);
  const [activityTotalCount, setActivityTotalCount] = useState(0);
  const [activityCartItems, setActivityCartItems] = useSessionStorageV1<any[]>("activity_cart_items", []);
  const [isFetchingActivities, setIsFetchingActivities] = useState(false);
  const [isActivityFormDirty, setIsActivityFormDirty] = useState(false);
  const [showActivityCollapsedHeader, setShowActivityCollapsedHeader] = useState(false);
  const [isActivityReviewPage, setIsActivityReviewPage] = useState(false);
  const [isMyTripsTheFirstSelectedScreen, setIsMyTripsTheFirstSelectedScreen] = useSessionStorage(
    "_first_selected_screen_while_booking",
    false
  );
  const [firstScreen, setFirstScreen] = useSessionStorageV1("first_screen_details", "");
  const [scriptLoaded, setScriptLoaded] = useState(false);
  // Deelinking Data for Airport Codes and dates
  const [deepLinkData, setDeepLinkData] = React.useState({
    start: "",
    end: "",
    currentDate: "",
  });
  const [metaData, setMetaData] = useSessionStorage("_trip_trove_itinerary_details", []);
  const [shareClick, setShareClick] = useSessionStorage("_trip_trove_share_click", false);
  /**
   * Edting Flag for Experience
   */
  const [editExperienceFlag, setEditExperienceFlag] = useSessionStorage("_trip_trove_edit_experience_flag", false);
  const [editClimatePopulationFlag, setEditClimatePopulationFlag] = useSessionStorage(
    "_trip_trove_edit_climate_population_flag",
    false
  );

  const [isAdmin, setIsAdmin] = useSessionStorage("_trip_trove_is_admin", true);
  const [isMobile, setIsMobile] = useState(true);
  const [isBottomDrawerOpen, setIsBottomDrawerOpen] = useState(false);
  const [isBookingSearchForm, setIsBookingSearchForm] = useState(false);

  const [departureAirPorts, setDepartureAirPorts] = useSessionStorageV1<any[]>("arrival", []);
  const [arrivalAirPorts, setArrivalAirPorts] = useSessionStorageV1<any[]>("departure", []);

  // Chat input text
  const [chatInputText, setChatInputText] = useSessionStorage("_trip_trove_chat_input_text", "");
  const [chatInputAutoFocusPending, setChatInputAutoFocusPending] = useState(false);

  // Itinerary details data
  const [itineraryDetailsData, setItineraryDetailsData] = useSessionStorage(
    "_trip_trove_itinerary_details",
    [] as iItineraryDetailsData[]
  );

  const [showMoreReqBody, setShowMoreReqBody] = useSessionStorage("_trip_trove_show_more_req_body", []);

  // Session-scoped (per-tab) via useSessionStorageV1. MUST NOT use
  // useSessionStorage — that hook persists to localStorage (its name is a
  // misnomer), so the conversation survived across real browser sessions. With
  // chat-search/orchestrator routing on, a stale rehydrated chatData fed
  // `derivePriorAgentKey` (→ priorAgentKey) so a brand-new "Hi" inherited the
  // previous session's agent (hotel/flight). sessionStorage still survives a
  // same-tab reload + the Stripe redirect round-trip, but a genuinely new
  // session cold-starts empty; the durable copy lives server-side (getHistory).
  const [chatData, setChatData] = useSessionStorageV1("_trip_trove_chat_data", [] as iChatData[]);

  // Clear stale streaming state rehydrated from storage on a fresh page load.
  // `chatData` (incl. each bubble's `isLoading`) is persisted to sessionStorage,
  // so refreshing mid-stream restores the loading bubble with `isLoading: true`.
  // The live WS recovery in TopDestinationContext only fires on a non-closed →
  // closed socket transition, which can't happen after a reload, so the
  // "Let me think about this..." loader would otherwise stay forever. No stream
  // can be in flight right after mount, so any `isLoading` is stale: clear it,
  // and surface the Try Again UI for empty assistant bubbles that never got a
  // frame (mirrors handleCancelStreaming's interrupted placeholder).
  useEffect(() => {
    setChatData((prev: iChatData[]) => {
      if (!prev?.some((ele) => ele?.isLoading)) return prev;
      return prev.map((ele) => {
        if (!ele?.isLoading) return ele;
        const hasContent =
          !!ele?.message?.trim() || !!ele?.preText?.trim() || (ele?.destinationList?.length ?? 0) > 0;
        return {
          ...ele,
          isLoading: false,
          isProcessInterrupted: ele?.isUserMessage || hasContent ? ele?.isProcessInterrupted : true,
        };
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [isUserNavigatingFromPaymentGateway, setIsUserNavigatingFromPaymentGateway] = useSessionStorage(
    "is_user_navigating_from_payment_gateway",
    false
  );
  const [toggle, setToggle] = useState("Log in");
  const [userIsNavigatingFrom, setIsUserNavigatingFrom] = useLocalStorage(
    "user_navigating_from",
    USER_NAVIGATING_TO_BOOKING_PAGE_FROM.ITINERARYDETAILSPAGE
  );
  // Session-scoped (per-tab) via useSessionStorageV1 — see chatData above. Feeds
  // `deriveActiveItinerary` (→ hasActiveItinerary) sent to the orchestrator, so
  // a stale cross-session itinerary here biased routing on a fresh "Hi". The
  // pre-Stripe-redirect safety write in TravelerCrumbsDetailsContext AND the
  // post-redirect read on /paymentsuccess both go through the sessionStorage
  // helpers, keeping one store + one (encrypted) encoding for this key.
  const [selectedChatData, setSelectedChatData] = useSessionStorageV1("_trip_trove_selected_chat_data", {} as iChatData);

  const [enableMultiSelect, setenableMultiSelect] = useSessionStorage("_trip_trove_enable_multi_select", false);

  const [openDetailsSliderFlag, setOpenDetailsSliderFlag] = useSessionStorage(
    "_trip_trove_open_details_slider_flag",
    false
  );

  const [isItinerarySavedFlag, setIsItinerarySavedFlag] = useSessionStorage(
    "_trip_trove_is_itinerary_saved_flag",
    false
  );

  const [userInfo, setUserInfo] = useLocalStorage<UserInfo>("user_info", {
    id: "",
    name: "",
    email: "",
    phone: "",
    profile_pic: "",
    loggedIn: false,
    role: 0,
    preferences: {},
    existingUser: false,
    loginType: "",
  });
  const [countriesData, setCountriesData] = useState<iCountryData[]>([]);

  const scrollContainerRef: any = useRef(null);
  const [flightTTL, setFlightTTL] = useSessionStorageV1<number | null>("_flight_ttl", null);
  const [isOpenMobileSidebar, setIsOpenMobileSidebar] = useState(false);
  const [onBoardForm, setOnBoardForm] = useSessionStorageV1<onBoardFormTypes>("onBoard", {
    home: {
      city: "",
      country: "",
      state: "",
    },
    travelWith: "",
    lookingFor: [],
    budget: "",
    selectedBudget: 1,
    isOfferAvailable: false,
    signUpOffer: "",
  });
  const [manageHotelsArr, setManageHotelsArr] = useSessionStorage("selected_manage_hotels", [] as any[]);
  const [stripePaymentFailureMessage, setStripePaymentFailureMessage] = useState("");

  const [myTripsItineraryId, setMyTripsItineraryId] = useSessionStorage("my_trips_itineraryId", "" as string);

  const [fetchItineraryDetails, setFetchItineraryDetails] = useState(false);
  const [enableContinueBtn, setEnableContinueBtn] = useState<boolean>(false);
  const [updateFilters, setUpdateFilters] = useState<boolean>(false);
  const [search, setSearch] = useState<searchOptionTypes>({
    flight: false,
    hotel: false,
    flightAvailability: false,
    flightDetails: false,
    baggageAndFareRules: false,
    fairFamily: false,
  });
  const [selectedFilterPrefType, setSelectedFilterPrefType] = useState<searchOptionTypes>({
    flight: false,
    hotel: false,
  });
  const [appConfig, setAppConfig] = useSessionStorage("_trip_trove_app_config", [] as iAppConfig[]);

  const [modifyItineraryPrompt, setModifyItineraryPrompt] = useSessionStorage(
    "_trip_trove_modify_itinerary_prompt",
    ""
  );
  const [promoCode, setPromoCode] = useSessionStorageV1<PromoDetail[]>(
    "_promoCode",
    [] // Start with an empty array since no data is fetched yet
  );
  const [airPorts, setAirPorts] = useSessionStorageV1<AirportDataTypes[]>(
    "_zenvoya_airPorts",
    [] // Start with an empty array since no data is fetched yet
  );
  const [flightChange, setFlightChange] = useSessionStorage<FlightChangeTypes>("flightChange", {
    flightCancel: false,
    flightChange: false,
  });
  const [templateDetails, setTemplateDetails] = useSessionStorageV1<TemplateData | null>("template", null);
  const [hotelPagination, setHotelPagination] = useSessionStorage<HotelPagination[]>("hotelPagination", []);
  const [isDataUpdateComplete, setIsDataUpdateComplete] = useSessionStorage<boolean>("dataUpdateStatus", false);
  const [showNextLoader, setShowNextLoader] = useState(false);
  const [bookingDetails, setBookingDetails] = useSessionStorageV1<BookingDetails>("_zenvoya_booking_fields", {
    adultsCount: 1,
    childrenCount: 0,
    seniorsCount: 0,
    infantCount: 0,
    infantLapCount: 0,
    numberOfRoomCount: 1,
    adultsHotelCount: 2,
    childrenHotelCount: 0,
    seniorsHotelCount: 0,
    infantHotelCount: 0,
    airportFrom: "",
    airportTo: "",
    travelFromDate: "",
    travelToDate: "",
    routeType: "",
    flightClass: "",
    tripType: 2,
    update: false,
    hideFlights: false,
    hideHotels: false,
    isThisMultiCityTrip: false,
    hotelUserRatings: 0,
    isFormUpdated: {
      arrivalForm: false,
      departureForm: false,
    },
    isDataModified: {
      flight: false,
      hotel: false,
    },
    selectedFlightId: "",
    selectedFlightIds: [],
    selectedFlightDetails: null,
    isFlightAvailable: false,
    airlines: null,
    hotelChains: null,
    accommodationTypes: null,
    flightDayPart: "",
    numberOfStops: "",
    flightRefundable: "",
    noMoreFlights: false,
    hotelUniqueId: "",
    expandedAccordions: [],
    numberOfDays: 0,
    isHotelSearchApiCalled: false,
    cityInfo: {
      departure: "",
      arrival: "",
    },
    selectedLocation: {
      city: "",
      state: "",
      country: "",
      latitude: 0,
      longitude: 0,
    },
    selectedArrivalLocation: {
      city: "",
      state: "",
      country: "",
      latitude: 0,
      longitude: 0,
    },
    flightPreferences: {
      connections: null,
      departureTime: [],
      refundable: false,
      airlines: [],
    },
    hotelPreferences: {
      refundable: false,
      hotelChains: [],
      accommodationTypes: [],
      userRatings: null,
      starRatings: [3, 4],
    },
    flightHistory: [
      {
        city_name: "",
        flights: [],
        number_of_days: 0,
      },
    ],
    hotels: [
      {
        checkIn: "",
        checkOut: "",
        country: "",
        city: "",
        latitude: "",
        longitude: "",
        cityNotAvailable: false,
        locality: "",
        isSelected: false,
        showOnlyInputField: true,
      },
    ],
    airPort: [
      {
        flightDepartureTime: "",
        returnTime: "",
        isSelected: false,
        arrivalAddress: "",
        departureAddress: "",
        arrivalGoogleAddress: "",
        departureGoogleAddress: "",
        newArrivalAddress: "",
        newDepartureAddress: "",
        departureCityAddress: "",
        arrivalCityAddress: "",
        arrival: "",
        departure: "",
        fromCity: "",
        destinationCity: "",
        departureDate: "",
        returnDate: "",
        departureAirportFullName: "",
        arrivalAirportFullName: "",
        arrivalCityLatitude: "",
        arrivalCityLongitude: "",
        departureCityLatitude: "",
        departureCityLongitude: "",
        noOfDays: 0,
        newArrivalCitySearch: false,
        newDepartureCitySearch: false,
        arrivalCityDetails: "",
        departureCityDetails: "",
        arrivalSelectedLocation: {
          city: "",
          state: "",
          country: "",
          latitude: 0,
          longitude: 0,
        },
        departureSelectedLocation: {
          city: "",
          state: "",
          country: "",
          latitude: 0,
          longitude: 0,
        },
        departureTimeInSlider: [],
      },
    ],
    travelJourneyData: [
      {
        departureCityAddress: "",
        arrivalCityAddress: "",
        departureDate: "",
        returnDate: "",
        days: [],
        flightCheckIn: "",
        flightCheckOut: "",
        totalDays: 0,
        flightTime: "",
      },
    ],
    visibleList: {
      flight: 0,
      hotel: {},
      package: 2,
    },
    filters: {
      starRating: [],
    },
    postBooking: [
      {
        transactionId: "",
        pnr: "",
        arrival: "",
        departure: "",
        fromCity: "",
        destinationCity: "",
        departureDate: "",
        returnDate: "",
        departureAirportFullName: "",
        arrivalAirportFullName: "",
        arrivalCityLatitude: "",
        arrivalCityLongitude: "",
        departureCityLatitude: "",
        departureCityLongitude: "",
        noOfDays: 0,
        arrivalCityDetails: "",
        departureCityDetails: "",
        arrivalCountryCode: "",
        arrivalCountryName: "",
        departureCountryCode: "",
        departureCountryName: "",
      },
    ],
    applyFilters: {
      flight: false,
      hotel: false,
    },
    roomInfo: [
      {
        roomNo: 1,
        adults: 2,
        child: 0,
        childAges: "",
      },
    ],
    bookingParams: false,
  });
  const [pixelSessionSent, setPixelSessionSent] = useSessionStorageV1<Boolean>("pixel_session_sent", false);
  const [pixelEventState, setPixelEventState] = useSessionStorageV1<any>("pixelEventState", {
    pageLoadPixelEventSent: false,
    signUpPixelEventSent: false,
    startChatPixelEventSent: false,
    viewItineraryPixelEventSent: false,
    searchFlightsPixelEventSent: false,
    searchStaysPixelEventSent: false,
    selectFlightsPixelEventSent: false,
    selectStaysPixelEventSent: false,
    reviewCartPixelEventSent: false,
    interactedWithChatPixelEventSent: false,
    loginPixelEventSent: false,
  });

  const [utmParams, setUtmParams] = useSessionStorageV1<string>("utmParams", "");
  const [utmSource, setUtmSource] = useSessionStorageV1<string>("utm_source", "");
  const [fbpIdLocal, setFbpId] = useSessionStorageV1<string>("fbpId", "");
  const [fbcIdLocal, setFbcId] = useSessionStorageV1<string>("fbcId", "");

  const [promoDetails, setPromoDetails] = useSessionStorageV1<PromosApplyResponse | null>("promo_details", null);
  const [selectedAirports, setSelectedAirports] = useSessionStorage<BookingDetails["airPort"]>("selected_flightsz", []);
  const [selectedHotels, setSelectedHotels] = useState<BookingDetails["hotels"]>(bookingDetails?.hotels || []);
  const [hideDetails, setHideDetails] = useLocalStorage<boolean>("hide", false);
  const [showMore, setShowMore] = useSessionStorage<showMoreTypes>("showMore", {
    visibleList: {
      flight: 12,
      hotel: 12,
      package: 2,
    },
  });
  const [selectFlight, setSelectFlight] = useSessionStorage<selectFlightTypes>("selectFlightInfo", {
    callAvailabilityApi: false,
    fairId: "",
    encryptedKey: "",
    uniqueId: "",
    flightCost: 0,
  });
  const [recentTravelersList, setRecentTravelersList] = useLocalStorage("_recent_travelers_list", []);
  const [flightData, setFlightData] = useSessionStorageV1<any>("flight_search", null);
  const [hotelData, setHotelData] = useSessionStorageV1<any>("hotel_search", null);
  const [bookedtransIds, setBookedTransIds] = useSessionStorage<any>("booked_transIds", null);
  const [clientSecret, setClientSecret] = useState<string>("");
  const [createItineraryPayload, setCreateItineraryPayload] = useSessionStorage<any>("create_itinerary_payload", null);
  const [showCancelHotelsModal, setShowCancelHotelsModal] = useState(false);
  const [bookClickFromItinerary, setBookClickFromItinerary] = useState(false);
  const [openAskZoya, setOpenAskZoya] = useState(false);
  const [airportAddress, setAirportAddress] = useState<airportAddressFieldTypes>({
    address: "",
    city: "",
    state: "",
    country: "",
    countryCode: "",
    latitude: 0,
    longitude: 0,
  });
  const [selectedFlightOptions, setSelectedFlightOptions] = useSessionStorageV1<FlightSelectedOptions>(
    "flight_SelectOption",
    {
      flights: true,
      hotels: false,
      activities: false,
    }
  );

  const [trigerredListItineraryAPIFlag, setTrigerredListItineraryAPIFlag] = useState(false);

  const [selectedCityListPrompContext, setSelectedCityListPrompContext] = useSessionStorage(
    "_trip_trove_city_list_prompt_context",
    null
  );

  const [flightPreferencesOptions, setFlightPreferencesOptions] = useSessionStorage("flight_preferences_options", {
    flightPreferencesScrollValue: 2,
    selectedTimings: [],
    isSelectedRefundable: false,
    selectedAirlineOptions: {},
  });
  const [hotelDetailsPageState, setHotelDetailsPageState] = useSessionStorage<any>("hotel_details_pagestate", null);

  const [flightAvailabilityData, setFlightAvailabilityData] = useSessionStorage(
    "_trip_trove_flight_availability_data",
    {}
  );

  const [showBookingPreferences, setShowBookingPreferences] = useState<boolean>(false);
  const [showRoomDetails, setShowRoomDetails] = useState(false);
  const [roomDetailsData, setRoomDetailsData] = useState<any>(null);
  const [cancellationData, setCancellationData] = useState<any>(null);
  const desktopScrollContainerRef: any = useRef(null);
  const [shouldAutoCallSearchFlightHotel, setShouldAutoCallSearchFlightHotel] = useState<boolean>(false);
  const [selectedCityIndex, setSelectedCityIndex] = React.useState(0);
  const [expandedHotelId, setExpandedHotelId] = useState(null);
  const [expandedHotelDetailsData, setExpandedHotelDetailsData] = useState<any>(null);
  const [isFetchingHotelDetailsByUnicaId, setIsFetchingHotelDetailsByUnicaId] = useState<boolean>(false);
  const [modifyHotels, setModifyHotels] = useState(false);
  const [triggeronBoardingEvent, setTriggeronBoardingEvent] = useState<boolean>(false);
  const [hasTriggeredPreBooking, setHasTriggeredPreBooking] = useLocalStorage(
    "_zenvoya_has_triggered_pre_booking",
    false
  );
  const [unavailableRoomIds, setUnavailableRoomIds] = useLocalStorage<string[]>("_zenvoya_unavailable_room_ids", []);
  const [unavailableFlightFareIds, setUnavailableFlightFareIds] = useLocalStorage<string[]>(
    "_zenvoya_unavailable_flight_fare_ids",
    []
  );
  const [showCancelActivitiesModal, setShowCancelActivitiesModal] = useState(false);
  const [manageActivitiesArr, setManageActivitiesArr] = useState<any[]>([]);
  const [activityCancelReasonCode, setActivityCancelReasonCode] = useState("");
  const [totalConfirmedActivities, setTotalConfirmedActivities] = useState(0);
  // True while a shared-cart link (?sharedCartId=) is being loaded — App shows
  // the review-page skeleton until the snapshot is reconstructed into the cart.
  const [sharedCartLoading, setSharedCartLoading] = useState<boolean>(false);

  const value = useMemo(
    () => ({
      sharedCartLoading,
      setSharedCartLoading,
      hasTriggeredPreBooking,
      setHasTriggeredPreBooking,
      recentTravelersList,
      setRecentTravelersList,
      userIsNavigatingFrom,
      setIsUserNavigatingFrom,
      abortController,
      abortControllerRef,
      openTripFromURL,
      setopenTripFromURL,
      isValidAccessToken,
      setSelectedCityIndex,
      selectedCityIndex,
      setIsValidAccessToken,
      accessJWT,

      setAccessJWT,
      countriesData,
      setCountriesData,
      cancellationData,
      setCancellationData,
      isCanclPolModalOpen,
      setIsCancPolModalOpen,
      activeBreadCrumbs,
      setActiveBreadCrumbs,
      breadList,
      setBreadList,
      roomDetailsData,
      setRoomDetailsData,
      setShowRoomDetails,
      showRoomDetails,
      fetchItineraryDetails,
      setFetchItineraryDetails,
      myTripsItineraryId,
      setMyTripsItineraryId,
      showCancelHotelsModal,
      setShowCancelHotelsModal,
      openLoaderOverlay,
      setOpenLoaderOverlay,
      manageHotelsArr,
      setManageHotelsArr,
      iosNativeLoginData,
      setIosNativeLoginData,
      bookClickBeforeLoginFlag,
      setBookClickBeforeLoginFlag,
      flightPreferencesOptions,
      setFlightPreferencesOptions,
      setShowBookingPreferences,
      showBookingPreferences,
      isUserJustBookedTrip,
      setIsUserJustBookedTrip,
      activeTripDetailsTab,
      setActiveTripDetailsTab,
      setShouldUserNavigateBackTotripDetailsPage,
      shouldUserNavigateBacktoTripDetailsPage,
      setIsFetchingHotelDetails,
      isFetchingHotelDetails,
      setIsFetchingAirports,
      isFetchingBaggageAndFare,
      setIsFetchingBaggageAndFare,
      isFetchingFare,
      setIsFetchingFare,
      isFetchingMobileAirports,
      setIsFetchingMobileAirports,
      isFetchingAirports,
      isFetchingFlights,
      isFetchingHotels,
      noFlightFound,
      setNoFlightFound,
      hotelInputFieldMissingError,
      setHotelInputFieldMissingError,
      flightInputFieldMissingError,
      setFlightInputFieldMissingError,
      isMyTripsTheFirstSelectedScreen,
      setIsMyTripsTheFirstSelectedScreen,
      setIsFetchingFlights,
      setIsFetchingHotels,
      isUserNavigatingFromPaymentGateway,
      setIsUserNavigatingFromPaymentGateway,
      selectedHotelRoomArr,
      setSelectedHotelRoomArr,
      setHotelData,
      hotelData,
      setSelectedHotelRoom,
      selectedHotelRoom,
      bookedtransIds,
      setBookedTransIds,
      setGetHotelRoomsBody,
      getHotelRoomsBody,
      hotelDetailsPageState,
      setHotelDetailsPageState,
      setShowPropertyDetails,
      openResultDetail,
      setOpenResultDetail,
      setShowReviews,
      showPropertyDetails,
      showReviewsModal,
      setHotelDetailsPageId,
      hotelDetailsPageId,
      openOverlayScreen,
      setOpenOverlayScreen,
      deepLinkData,
      setDeepLinkData,
      tripPlanDataStream,
      setTripPlanDataStream,
      query,
      setQuery,
      dataStream,
      setDataStream,
      startDestCountry,
      setStartDestCountry,
      abortTripAPICall,
      setAbortTripAPICall,
      startingValue,
      setStartingValue,
      destValue,
      setDestValue,
      userLocation,
      setUserLocation,
      nav,
      setNav,
      climate,
      setClimate,
      population,
      setPopulation,
      experience,
      setExperience,
      data,
      setData,
      latLong,
      setLatLong,
      apiResponse,
      setApiResponse,
      headerBackground,
      setHeaderBackground,
      zip,
      setZip,
      firstTwoCategoryState,
      setFirstTwoCategoryState,
      selectedDestFlag,
      setSelectedDestFlag,
      accomodations,
      setAccomodations,
      foodPreferences,
      setFoodPreferences,
      months,
      setMonths,
      budget,
      setBudget,
      menuOpenState,
      setMenuOpenState,
      loginCreateAccountState,
      setLoginCreateAccountState,
      saveScreenState,
      setSaveScreenState,
      isLogin,
      setIsLogin,
      prevNav,
      setPrevNav,
      internationDest,
      setInternationalDest,
      prevRoute,
      setPrevRoute,
      isLoggedIn,
      setIsLoggedIn,
      sliderValue,
      setSliderValue,
      signInClick,
      setSignInClick,
      itinerayDetails,
      setItineraryDetails,
      tripForNDays,
      setTripForNDays,
      addMoreId,
      setAddMoreId,
      moreButton,
      setMoreButton,
      expHeight,
      setExpHeight,
      singleItineraryDetails,
      setSingleItineraryDetails,
      fetchingPlanTripMessage,
      setFetchingPlanTripMessage,
      resetPasswordToken,
      setResetPasswordToken,
      extraMeta,
      setExtraMeta,
      editViewState,
      setEditViewState,
      sharedItineraryId,
      setSharedItineraryId,
      itineraryDetailsLoad,
      setItineraryDetailsLoad,
      showMoreFlag,
      setShowMoreFlag,
      metaData,
      setMetaData,
      shareClick,
      setShareClick,
      editExperienceFlag,
      setEditExperienceFlag,
      editClimatePopulationFlag,
      setEditClimatePopulationFlag,
      isAdmin,
      setIsAdmin,
      isMobile,
      setIsMobile,
      isBottomDrawerOpen,
      setIsBottomDrawerOpen,
      isBookingSearchForm,
      setIsBookingSearchForm,
      chatInputText,
      setChatInputText,
      chatInputAutoFocusPending,
      setChatInputAutoFocusPending,
      itineraryDetailsData,
      setItineraryDetailsData,
      showMoreReqBody,
      setShowMoreReqBody,
      chatData,
      setChatData,
      selectedChatData,
      setSelectedChatData,
      enableMultiSelect,
      setenableMultiSelect,
      setAirportAddress,
      airportAddress,
      openDetailsSliderFlag,
      setOpenDetailsSliderFlag,
      isItinerarySavedFlag,
      setIsItinerarySavedFlag,
      scrollContainerRef,
      screen,
      setScreen,
      firstScreen,
      setFirstScreen,
      scriptLoaded,
      setScriptLoaded,
      userInfo,
      setUserInfo,
      bookingDetails,
      setBookingDetails,
      showMore,
      setShowMore,
      flightData,
      setFlightData,
      isOpenMobileSidebar,
      setIsOpenMobileSidebar,
      appConfig,
      setAppConfig,
      modifyItineraryPrompt,
      setModifyItineraryPrompt,
      trigerredListItineraryAPIFlag,
      setTrigerredListItineraryAPIFlag,
      selectedCityListPrompContext,
      setSelectedCityListPrompContext,
      selectedFlightOptions,
      setSelectedFlightOptions,
      showSelectRoomModal,
      setShowSelectRoomModal,
      flightAvailabilityData,
      setFlightAvailabilityData,
      tripOrItinearyId,
      setTripOrItinearyId,
      isCheckingFlight,
      setIsCheckingFlight,
      checkFlightDetails,
      setCheckFlightDetails,
      setAirPorts,
      airPorts,
      hotelPagination,
      setHotelPagination,
      myTripActiveTab,
      setMyTripActiveTab,
      hasMoreTripPagination,
      setHasMoreTripPagination,
      inputFocus,
      setInputFocus,
      setFlightChange,
      flightChange,
      setItineraryId,
      itineraryId,
      modifyFlightStatus,
      setModifyFlightStatus,
      expandedFlightId,
      setExpandedFlightId,
      socketId,
      setSocketId,
      selectedAirports,
      setSelectedAirports,
      selectedHotels,
      setSelectedHotels,
      hideDetails,
      setHideDetails,
      enableContinueBtn,
      setEnableContinueBtn,
      updateFilters,
      setUpdateFilters,
      baggageAndFareRules,
      setBaggageAndFareRules,
      selectedFilterPrefType,
      setSelectedFilterPrefType,
      desktopScrollContainerRef,
      search,
      setSearch,
      createItineraryPayload,
      setCreateItineraryPayload,
      isDataUpdateComplete,
      setIsDataUpdateComplete,
      signUp,
      setSignUp,
      hotelTravelersList,
      setHotelTravelersList,
      guestList,
      setGuestList,
      shouldAutoCallSearchFlightHotel,
      setShouldAutoCallSearchFlightHotel,
      searchBeforeLoginFlag,
      setSearchBeforeLoginFlag,
      stripePaymentFailureMessage,
      setStripePaymentFailureMessage,
      clientSecret,
      setClientSecret,
      payDetails,
      setPayDetails,
      showNextLoader,
      setShowNextLoader,
      flightChatData,
      setFlightChatData,
      hotelChatData,
      setHotelChatData,
      askZoyaRecordId,
      setAskZoyaRecordId,
      expandedHotelId,
      setExpandedHotelId,
      expandedHotelDetailsData,
      setExpandedHotelDetailsData,
      isFetchingHotelDetailsByUnicaId,
      setIsFetchingHotelDetailsByUnicaId,
      showZoho,
      setShowZoho,
      viewPreference,
      setViewPreference,
      modifyHotels,
      setModifyHotels,
      bookClickFromItinerary,
      setBookClickFromItinerary,
      fareId,
      setFareId,
      fareDetails,
      setFareDetails,
      selectFlight,
      setSelectFlight,
      selectedFareContext,
      setSelectedFareContext,
      isUpdatingPaymentDetails,
      setIsUpdatingPaymentDetails,
      promoDetails,
      setPromoDetails,
      flightTTL,
      setFlightTTL,
      cancelHandleBookClickRef,
      pixelSessionSent,
      setPixelSessionSent,
      isFetchingPreference,
      setIsFetchingPreference,
      setPixelEventState,
      pixelEventState,
      utmParams,
      setUtmParams,
      toggle,
      setToggle,
      onBoardForm,
      setOnBoardForm,
      onBoardingStep,
      setOnBoardingStep,
      isAdminChat,
      setIsAdminChat,
      onboardingOpenFrom,
      setOnboardingOpenFrom,
      promptTemplate,
      setPromptTemplate,
      triggeronBoardingEvent,
      setTriggeronBoardingEvent,
      departureAirPorts,
      arrivalAirPorts,
      setDepartureAirPorts,
      setArrivalAirPorts,
      fbpIdLocal,
      setFbpId,
      fbcIdLocal,
      setFbcId,
      utmSource,
      setUtmSource,
      templateDetails,
      setTemplateDetails,
      promoReviewCartData,
      setPromoReviewCartData,
      promoCode,
      setPromoCode,
      destinationListGeneratedGAEventsFlag,
      setDestinationListGeneratedGAEventsFlag,
      showHotelRoomDetails,
      setShowHotelRoomDetails,
      isLazyLoaded,
      setIsLazyLoaded,
      openAskZoya,
      setOpenAskZoya,
      selectRoom,
      setSelectRoom,
      openLeaveReviewDialog,
      setOpenLeaveReviewDialog,
      showWhoComingWithYouModal,
      setShowWhoComingWithYouModal,
      activityData,
      setActivityData,
      activitySearchParams,
      setActivitySearchParams,
      selectedTicketActivity,
      setSelectedTicketActivity,
      activityTotalCount,
      setActivityTotalCount,
      activityCartItems,
      setActivityCartItems,
      isFetchingActivities,
      setIsFetchingActivities,
      isActivityFormDirty,
      setIsActivityFormDirty,
      showActivityCollapsedHeader,
      setShowActivityCollapsedHeader,
      isActivityReviewPage,
      setIsActivityReviewPage,
      unavailableRoomIds,
      setUnavailableRoomIds,
      unavailableFlightFareIds,
      setUnavailableFlightFareIds,
      showCancelActivitiesModal,
      setShowCancelActivitiesModal,
      manageActivitiesArr,
      setManageActivitiesArr,
      activityCancelReasonCode,
      setActivityCancelReasonCode,
      totalConfirmedActivities,
      setTotalConfirmedActivities,
      isEmbed,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      sharedCartLoading,
      setSharedCartLoading,
      hasTriggeredPreBooking,
      setHasTriggeredPreBooking,
      openAskZoya,
      setOpenAskZoya,
      destinationListGeneratedGAEventsFlag,
      setDestinationListGeneratedGAEventsFlag,
      promoReviewCartData,
      setPromoReviewCartData,
      promptTemplate,
      setPromptTemplate,
      onboardingOpenFrom,
      setOnboardingOpenFrom,
      isAdminChat,
      setIsAdminChat,
      pixelSessionSent,
      setPixelSessionSent,
      cancelHandleBookClickRef,
      askZoyaRecordId,
      setAskZoyaRecordId,
      flightChatData,
      setFlightChatData,
      hotelChatData,
      setHotelChatData,
      searchBeforeLoginFlag,
      setSearchBeforeLoginFlag,
      recentTravelersList,
      setRecentTravelersList,
      userIsNavigatingFrom,
      setIsUserNavigatingFrom,
      abortController,
      openTripFromURL,
      setopenTripFromURL,
      isValidAccessToken,
      setIsValidAccessToken,
      accessJWT,
      setAccessJWT,
      countriesData,
      cancellationData,
      isCanclPolModalOpen,
      activeBreadCrumbs,
      breadList,
      roomDetailsData,
      showRoomDetails,
      fetchItineraryDetails,
      myTripsItineraryId,
      setMyTripsItineraryId,
      showCancelHotelsModal,
      openLoaderOverlay,
      manageHotelsArr,
      setManageHotelsArr,
      iosNativeLoginData,
      setIosNativeLoginData,
      bookClickBeforeLoginFlag,
      flightPreferencesOptions,
      setFlightPreferencesOptions,
      setShowBookingPreferences,
      showBookingPreferences,
      isUserJustBookedTrip,
      setIsUserJustBookedTrip,
      activeTripDetailsTab,
      setActiveTripDetailsTab,
      setShouldUserNavigateBackTotripDetailsPage,
      shouldUserNavigateBacktoTripDetailsPage,
      isFetchingHotelDetails,
      isFetchingMobileAirports,
      isFetchingAirports,
      isFetchingFlights,
      isFetchingHotels,
      noFlightFound,
      isMyTripsTheFirstSelectedScreen,
      setIsMyTripsTheFirstSelectedScreen,
      isUserNavigatingFromPaymentGateway,
      setIsUserNavigatingFromPaymentGateway,
      selectedHotelRoomArr,
      setSelectedHotelRoomArr,
      setHotelData,
      hotelData,
      setSelectedHotelRoom,
      selectedHotelRoom,
      bookedtransIds,
      setBookedTransIds,
      setGetHotelRoomsBody,
      getHotelRoomsBody,
      hotelDetailsPageState,
      setHotelDetailsPageState,
      setShowPropertyDetails,
      openResultDetail,
      setOpenResultDetail,
      setShowReviews,
      showPropertyDetails,
      showReviewsModal,
      setHotelDetailsPageId,
      hotelDetailsPageId,
      openOverlayScreen,
      setOpenOverlayScreen,
      deepLinkData,
      tripPlanDataStream,
      query,
      setQuery,
      dataStream,
      startDestCountry,
      abortTripAPICall,
      startingValue,
      destValue,
      userLocation,
      setUserLocation,
      nav,
      setNav,
      climate,
      setClimate,
      population,
      setPopulation,
      experience,
      setExperience,
      data,
      latLong,
      apiResponse,
      setApiResponse,
      headerBackground,
      zip,
      firstTwoCategoryState,
      selectedDestFlag,
      setSelectedDestFlag,
      accomodations,
      setAccomodations,
      foodPreferences,
      setFoodPreferences,
      months,
      setMonths,
      budget,
      setBudget,
      menuOpenState,
      loginCreateAccountState,
      saveScreenState,
      isLogin,
      prevNav,
      setPrevNav,
      internationDest,
      prevRoute,
      setPrevRoute,
      isLoggedIn,
      sliderValue,
      signInClick,
      itinerayDetails,
      tripForNDays,
      setTripForNDays,
      addMoreId,
      moreButton,
      expHeight,
      singleItineraryDetails,
      setSingleItineraryDetails,
      fetchingPlanTripMessage,
      resetPasswordToken,
      extraMeta,
      setExtraMeta,
      editViewState,
      sharedItineraryId,
      setSharedItineraryId,
      itineraryDetailsLoad,
      showMoreFlag,
      metaData,
      setMetaData,
      shareClick,
      setShareClick,
      editExperienceFlag,
      setEditExperienceFlag,
      editClimatePopulationFlag,
      setEditClimatePopulationFlag,
      isAdmin,
      setIsAdmin,
      isMobile,
      isBottomDrawerOpen,
      isBookingSearchForm,
      chatInputText,
      setChatInputText,
      chatInputAutoFocusPending,
      setChatInputAutoFocusPending,
      itineraryDetailsData,
      setItineraryDetailsData,
      showMoreReqBody,
      setShowMoreReqBody,
      chatData,
      setChatData,
      selectedChatData,
      setSelectedChatData,
      enableMultiSelect,
      setenableMultiSelect,
      airportAddress,
      openDetailsSliderFlag,
      setOpenDetailsSliderFlag,
      isItinerarySavedFlag,
      setIsItinerarySavedFlag,
      screen,
      setScreen,
      firstScreen,
      setFirstScreen,
      scriptLoaded,
      setScriptLoaded,
      userInfo,
      setUserInfo,
      bookingDetails,
      setBookingDetails,
      showMore,
      setShowMore,
      flightData,
      setFlightData,
      isOpenMobileSidebar,
      setIsOpenMobileSidebar,
      appConfig,
      setAppConfig,
      modifyItineraryPrompt,
      setModifyItineraryPrompt,
      trigerredListItineraryAPIFlag,
      selectedCityListPrompContext,
      setSelectedCityListPrompContext,
      selectedFlightOptions,
      setSelectedFlightOptions,
      showSelectRoomModal,
      flightAvailabilityData,
      setFlightAvailabilityData,
      tripOrItinearyId,
      setTripOrItinearyId,
      isCheckingFlight,
      checkFlightDetails,
      setAirPorts,
      airPorts,
      hotelPagination,
      setHotelPagination,
      myTripActiveTab,
      setMyTripActiveTab,
      hasMoreTripPagination,
      inputFocus,
      setFlightChange,
      flightChange,
      setItineraryId,
      itineraryId,
      modifyFlightStatus,
      setModifyFlightStatus,
      expandedFlightId,
      socketId,
      setSocketId,
      selectedAirports,
      setSelectedAirports,
      selectedHotels,
      enableContinueBtn,
      baggageAndFareRules,
      selectedFilterPrefType,
      search,
      createItineraryPayload,
      setCreateItineraryPayload,
      isDataUpdateComplete,
      setIsDataUpdateComplete,
      signUp,
      setSignUp,
      hotelTravelersList,
      setHotelTravelersList,
      guestList,
      setGuestList,
      shouldAutoCallSearchFlightHotel,
      setShouldAutoCallSearchFlightHotel,
      setSelectedCityIndex,
      selectedCityIndex,
      stripePaymentFailureMessage,
      setStripePaymentFailureMessage,
      clientSecret,
      setClientSecret,
      payDetails,
      setPayDetails,
      showNextLoader,
      setShowNextLoader,
      expandedHotelId,
      setExpandedHotelId,
      expandedHotelDetailsData,
      setExpandedHotelDetailsData,
      isFetchingHotelDetailsByUnicaId,
      setIsFetchingHotelDetailsByUnicaId,
      updateFilters,
      setUpdateFilters,
      showZoho,
      setShowZoho,
      viewPreference,
      setViewPreference,
      modifyHotels,
      setModifyHotels,
      bookClickFromItinerary,
      setBookClickFromItinerary,
      fareId,
      setFareId,
      fareDetails,
      setFareDetails,
      selectFlight,
      setSelectFlight,
      selectedFareContext,
      setSelectedFareContext,
      isUpdatingPaymentDetails,
      setIsUpdatingPaymentDetails,
      promoDetails,
      setPromoDetails,
      flightTTL,
      setFlightTTL,
      isFetchingBaggageAndFare,
      setIsFetchingBaggageAndFare,
      isFetchingFare,
      setIsFetchingFare,
      isFetchingPreference,
      setIsFetchingPreference,
      setPixelEventState,
      pixelEventState,
      utmParams,
      setUtmParams,
      toggle,
      setToggle,
      onBoardForm,
      setOnBoardForm,
      onBoardingStep,
      setOnBoardingStep,
      triggeronBoardingEvent,
      setTriggeronBoardingEvent,
      departureAirPorts,
      arrivalAirPorts,
      setDepartureAirPorts,
      setArrivalAirPorts,
      fbpIdLocal,
      setFbpId,
      fbcIdLocal,
      setFbcId,
      utmSource,
      setUtmSource,
      templateDetails,
      setTemplateDetails,
      promoCode,
      setPromoCode,
      showHotelRoomDetails,
      setShowHotelRoomDetails,
      isLazyLoaded,
      setIsLazyLoaded,
      selectRoom,
      setSelectRoom,
      openLeaveReviewDialog,
      setOpenLeaveReviewDialog,
      showWhoComingWithYouModal,
      setShowWhoComingWithYouModal,
      activityData,
      setActivityData,
      activitySearchParams,
      setActivitySearchParams,
      selectedTicketActivity,
      setSelectedTicketActivity,
      activityTotalCount,
      setActivityTotalCount,
      activityCartItems,
      setActivityCartItems,
      isFetchingActivities,
      setIsFetchingActivities,
      isActivityFormDirty,
      setIsActivityFormDirty,
      showActivityCollapsedHeader,
      setShowActivityCollapsedHeader,
      isActivityReviewPage,
      setIsActivityReviewPage,
      unavailableRoomIds,
      setUnavailableRoomIds,
      unavailableFlightFareIds,
      setUnavailableFlightFareIds,
      showCancelActivitiesModal,
      manageActivitiesArr,
      activityCancelReasonCode,
    ]
  );
  return <StateContext.Provider value={value}>{children}</StateContext.Provider>;
}
